export const SELECTED_GROUP_URL_KEY = "selected_group";
export const SELECTED_PIPELINE_URL_KEY = "selected_pipeline_id";
